export default __webpack_public_path__ + "static/media/3、首页多多柠檬茶.7367e506.jpg";